module.exports = __webpack_public_path__ + "r-v3/img/exam_check_red.4cd2bde2.svg";